import {Select} from '@wandb/weave/components/Form/Select';
import React, {FC, useState} from 'react';
import {SingleValue} from 'react-select';

import {Axis} from '../../../../PanelMediaBrowser/common';
import {
  ColumnContentOption,
  getAxisOptions,
} from '../../../../PanelMediaBrowser/PanelSettings';
import {SettingTitle} from '../common/SettingTitle';
import {MediaSettingProps} from '../types';

export const ColumnContent: FC<MediaSettingProps> = ({
  config,
  updateConfig,
  inRunPage,
}) => {
  const multiRun = !inRunPage;
  const axisOptions = getAxisOptions(multiRun);
  const [selectedOption, setSelectedOption] = useState<Axis>(
    config.gallerySettings.axis
  );
  const onChangeDropdown = (option: SingleValue<ColumnContentOption>) => {
    if (option) {
      setSelectedOption(option.value);
      updateConfig({gallerySettings: {axis: option.value}});
    }
  };
  return (
    <div className="flex flex-col">
      <SettingTitle title="Column content" />
      <Select<ColumnContentOption>
        className="w-full"
        aria-label="Column content"
        options={axisOptions}
        getOptionLabel={option => option.text}
        value={axisOptions.find(option => option.value === selectedOption)}
        onChange={onChangeDropdown}
      />
    </div>
  );
};
